export default __webpack_public_path__ + "Icon/icons/filled/batteryChargingFull.svg";